import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import { BannerDto } from '../../../core/data/dtos/banner.dto';

@Injectable()
export class BannersService extends BaseCrudService<BannerDto> {
  controller = 'banner';

  private fallbackBanners(): BannerDto[] {
    return [
      {
        acf: {
          banner_portada_web: false,
          banner_portada_web_img: null,
          enlace_del_banner_portada_web: null,
          banner_portada_app_movil: false,
          banner_portada_app_movil_img: null,
          enlace_del_banner_portada_app_movil: null,
          banner_portada_oficina_virtual: true,
          banner_portada_oficina_virtual_img:
            'https://lacolonial.com.do/sites/default/files/2024-02/Viaja-Seguro-La-Colonial_1980x620.jpg',
          enlace_del_banner_portada_oficina_virtual:
            'https://www.viajaseguro.do/',
        },
      },
      {
        acf: {
          banner_portada_web: false,
          banner_portada_web_img: null,
          enlace_del_banner_portada_web: null,
          banner_portada_app_movil: false,
          banner_portada_app_movil_img: null,
          enlace_del_banner_portada_app_movil: null,
          banner_portada_oficina_virtual: true,
          banner_portada_oficina_virtual_img:
            'https://lacolonial.com.do/sites/default/files/2022-10/BannerHome_1980x620.jpg',
          enlace_del_banner_portada_oficina_virtual:
            'https://armalotu.com.do/armalotu',
        },
      },
    ];
  }

  async getBanners() {
    let response: BannerDto[];

    try {
      response = await lastValueFrom(
        this.httpClient.get<BannerDto[]>(this.controller),
      );
    } catch {
      response = this.fallbackBanners();
    }

    return response.filter(
      (x) =>
        x.acf.banner_portada_oficina_virtual &&
        x.acf.banner_portada_oficina_virtual_img &&
        x.acf.enlace_del_banner_portada_oficina_virtual,
    );
  }
}
